import { css } from "lit";

export const styles = css`
  :host {
    display: contents;
  }

  .overlay {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--sds-color-background-utilities-overlay);
    backdrop-filter: blur(var(--sds-size-blur-100));
  }

  .dialog {
    background: var(--sds-color-background-default-default);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-600);
    padding: var(--sds-size-space-800);
    margin: 0 var(--sds-size-space-800);
    width: calc(100% - 2 * var(--sds-size-space-800));
    max-width: 420px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    box-shadow:
      0 var(--sds-size-depth-400) var(--sds-size-depth-800) var(--sds-size-depth-negative-100)
        var(--sds-color-black-200),
      0 var(--sds-size-depth-200) var(--sds-size-depth-200) var(--sds-size-depth-negative-100)
        var(--sds-color-black-100);
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-03) var(--sds-typography-family-title);
    color: var(--sds-color-text-default-default);
    line-height: 20px;
  }

  .close-button {
    background: none;
    border: none;
    color: var(--sds-color-text-default-default);
    cursor: pointer;
    padding: var(--sds-size-space-200);
    border-radius: var(--sds-size-radius-full);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .close-button:hover {
    color: var(--sds-color-icon-default-default);
    background-color: var(--sds-color-background-default-secondary);
  }

  .description {
    margin: 0;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-03) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    opacity: 0.7;
    line-height: 140%;
  }

  .buttons {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
  }

  .buttons ::slotted(wow-button) {
    --wow-button-display: block;
    --wow-button-width: 100%;
    --wow-button-inner-display: flex;
    --wow-button-inner-width: 100%;
    --wow-button-inner-font-size: 16px;
    --wow-button-inner-font-weight: 500;
  }
`;
